// Native
import { useState } from "react"
import { ButtonGroup, DataList, DialogBody, DialogFooter, IconButton } from "@chakra-ui/react"

// Custom
import { UI } from "components"
import { API, toaster } from "config"
import useBankAccounts from "hooks/useBankAccounts"
import useUser from "hooks/useUser"

export default function View({ data, ...props }){

    const user = useUser()
    const bank_accounts = useBankAccounts()
    const [ loading, setLoading ] = useState(false)

    const handleDelete = async () => {
        if(!window.confirm('Tem certeza que deseja remover esta conta bancária?')) return
        setLoading(true)

        try{
            await API.delete(`/bank_accounts/${data?.id}`)
            toaster.create({ title: 'Conta bancária removida', status: 'info' })
            props.onClose()
            bank_accounts.refetch()
        }catch(err){
            toaster.create({ title: 'Não foi possível excluir a conta.', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    return(
    <UI.Dialog loading={loading} size="sm" title="Conta Bancária" {...props}>
        <DialogBody>

            <DataList.Root orientation="horizontal">

                <DataList.Item>
                    <DataList.ItemLabel children="Instituição:" />
                    <DataList.ItemValue children={`${data?.bank?.bc_compe} - ${data?.bank?.name}`} />
                </DataList.Item>

                <DataList.Item>
                    <DataList.ItemLabel children="Tipo de conta:" />
                    <DataList.ItemValue children={data?.pix_key ? 'Chave Pix' : 'Conta Bancária'} />
                </DataList.Item>

                <UI.Show visible={!!data?.pix_key}>

                    <DataList.Item>
                        <DataList.ItemLabel children="Chave:" />
                        <DataList.ItemValue>
                            {data?.pix_type_label}: <b>{data?.pix_key}</b>
                        </DataList.ItemValue>
                    </DataList.Item>

                </UI.Show>

                <UI.Show visible={!data?.pix_key}>

                    <DataList.Item>
                        <DataList.ItemLabel children="Agência:" />
                        <DataList.ItemValue children={data?.agency} />
                    </DataList.Item>

                    <DataList.Item>
                        <DataList.ItemLabel children="Conta:" />
                        <DataList.ItemValue children={data?.account} />
                    </DataList.Item>

                </UI.Show>

                <DataList.Item>
                    <DataList.ItemLabel children="Titular:" />
                    <DataList.ItemValue children={user.data?.name} />
                </DataList.Item>

            </DataList.Root>

        </DialogBody>

        <DialogFooter>
            <ButtonGroup>
                <IconButton size="xs" colorPalette="red" loading={loading} onClick={handleDelete}><UI.Icon name="trash" /></IconButton>
            </ButtonGroup>
        </DialogFooter>
    </UI.Dialog>
    )
}